module.exports = __webpack_public_path__ + "static/39-fa843f8d4934cc5ddd2d6cdc12376982.png";